import type { RouteRecordRaw } from "vue-router";

import { assistantRoutes } from "./assistantRoutes";
import { chatRoutes } from "./chatRoutes";
import { converterRoutes } from "./converterRoutes";
import { documentQaRoutes } from "./documentQaRoutes";
import { feedbackRoutes } from "./feedbackRoutes";
import { imageRoutes } from "./imageRoutes";
import { miniToolRoutes } from "./miniToolRoutes";
import { personaRoutes } from "./personaRoutes";

export const aiRoutes: RouteRecordRaw[] = [
  ...chatRoutes,
  ...assistantRoutes,
  ...feedbackRoutes,
  ...imageRoutes,
  ...converterRoutes,
  ...documentQaRoutes,
  ...miniToolRoutes,
  ...personaRoutes,
];
